// extracted by mini-css-extract-plugin
export default {"main":"style_main__OewCB","autoScroll":"style_autoScroll__d1kDk","container":"style_container__q93IE"};